module.exports = __webpack_public_path__ + "img/cast_ic_bootcamps.bec416a3.svg";